import { RouteSegments } from '../routingClientAdmin.interface';

export const generateSyntheticSymbolRoute = (id?: number | string) => {
  const pageUrl = `/${RouteSegments.Root.Config}/${RouteSegments.Config.Symbols}/${RouteSegments.Symbols.Synthetic}`;

  if (id) {
    return `${pageUrl}/${id}`;
  }

  return pageUrl;
};
